import React, { useState, useEffect } from 'react';
import { db, auth, storage } from '../../../Firebase/Firebase';
import { collection, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { onAuthStateChanged } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';
import './CrearServicio.css';
import Navbar from '../../../Components/NavBarAirbnbStyle';
import LoadingScreen from '../../../Components/loading';
import Footer from '../../../Components/footer';
import MapaSeleccion from '../../../Components/maps/MapaSeleccion';
import NavbarMobileVersion from '../../../Components/NavBar/NavBarMobileVersion';
import * as FaIcons from 'react-icons/fa';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
const CrearServicio = () => {
  const [uid, setUid] = useState(null);
  const [portafolioFiles, setPortafolioFiles] = useState([]);
  const [step, setStep] = useState(0);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('');

  const [categorias, setCategorias] = useState([]);
  const [fotoFile, setFotoFile] = useState(null);
  const navigate = useNavigate();
  // Datos del servicio
  const [servicio, setServicio] = useState({
    categoria: '',
    nombre: '',
    descripcion: '',
    imagenURL: '',
    bio: '',
    modalidad: '',
    instruccionesReserva: '',
    faq: [{ pregunta: '', respuesta: '' }],
    paquetes: [{ nombre: '', descripcion: '', precio: '' }],
    testimonios: [], // opcional, no lo llenamos aquí
    ubicacion: null, // { lat: ..., lng: ... }

  });
  const setUbicacion = (loc) => {
    setServicio(prev => ({ ...prev, ubicacion: loc }));
  };

  const handleFotoChange = (e) => {
    if (e.target.files[0]) setFotoFile(e.target.files[0]);
  };

  const [mensaje, setMensaje] = useState('');
  const [guardando, setGuardando] = useState(false);

  // Cargar usuario autenticado
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      if (user) setUid(user.uid);
      else setUid(null);
    });
    return unsubscribe;
  }, []);

  const handleCategoriaClick = (categoria) => {
    setCategoriaSeleccionada(categoria);
  };

  const handleSiguiente = () => {
    if (categoriaSeleccionada) {
      setStep(step + 1);
    } else {
      alert('Por favor selecciona una categoría');
    }
  };
  const handleAnterior = () => {
    setStep(step - 1);
  }

  // Cargar categorías
  useEffect(() => {
    const cargarCategorias = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'categorias'));
        const cats = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setCategorias(cats);
      } catch (error) {
        console.error('Error cargando categorías:', error);
      }
    };
    cargarCategorias();
  }, []);

  // Manejar cambio simple en inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setServicio(prev => ({ ...prev, [name]: value }));
  };

  // Manejar cambio en FAQ dinámicos
  const handleFaqChange = (index, field, value) => {
    const newFaq = [...servicio.faq];
    newFaq[index][field] = value;
    setServicio(prev => ({ ...prev, faq: newFaq }));
  };

  const agregarFaq = () => {
    if (servicio.faq.length < 5) {
      setServicio(prev => ({ ...prev, faq: [...prev.faq, { pregunta: '', respuesta: '' }] }));
    }
  };

  const eliminarFaq = (index) => {
    const newFaq = servicio.faq.filter((_, i) => i !== index);
    setServicio(prev => ({ ...prev, faq: newFaq }));
  };

  // Manejar cambio en paquetes dinámicos
  const handlePaqueteChange = (index, field, value) => {
    const newPaquetes = [...servicio.paquetes];
    newPaquetes[index][field] = value;
    setServicio(prev => ({ ...prev, paquetes: newPaquetes }));
  };

  const agregarPaquete = () => {
    if (servicio.paquetes.length < 3) {
      setServicio(prev => ({ ...prev, paquetes: [...prev.paquetes, { nombre: '', descripcion: '', precio: '' }] }));
    }
  };

  const eliminarPaquete = (index) => {
    const newPaquetes = servicio.paquetes.filter((_, i) => i !== index);
    setServicio(prev => ({ ...prev, paquetes: newPaquetes }));
  };

  // Validar datos mínimos
  const validar = () => {
    if (!categoriaSeleccionada) return 'Debe seleccionar una categoría.';
    if (!servicio.nombre.trim()) return 'Debe ingresar el nombre del servicio.';
    if (!servicio.descripcion.trim()) return 'Debe ingresar la descripción.';
    if (servicio.paquetes.length === 0) return 'Debe ingresar al menos un paquete.';
    for (const paquete of servicio.paquetes) {
      if (!paquete.nombre.trim() || !paquete.descripcion.trim() || !paquete.precio) {
        return 'Todos los paquetes deben tener nombre, descripción y precio.';
      }
      if (isNaN(Number(paquete.precio)) || Number(paquete.precio) <= 0) {
        return 'El precio del paquete debe ser un número mayor que cero.';
      }
    }
    return null;
  };

  // Guardar servicio con subida de foto
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!uid) {
      setMensaje('Debes estar autenticado para crear un servicio.');
      return;
    }

    const errorValidacion = validar();
    if (errorValidacion) {
      setMensaje(errorValidacion);
      return;
    }

    setGuardando(true);

    setMensaje('');

    try {
      let imagenURL = servicio.imagenURL;

      if (fotoFile) {
        // Subir imagen a Firebase Storage
        const storageRef = ref(storage, `serviciosFotos/${uuidv4()}_${fotoFile.name}`);
        await uploadBytes(storageRef, fotoFile);
        imagenURL = await getDownloadURL(storageRef);
      }
      let portafolioUrls = [];

      if (portafolioFiles.length > 0) {
        for (const file of portafolioFiles) {
          const ext = file.name.split('.').pop();
          const storageRef = ref(storage, `serviciosPortafolio/${uuidv4()}.${ext}`);
          await uploadBytes(storageRef, file);
          const url = await getDownloadURL(storageRef);
          portafolioUrls.push(url);
        }
      }

      await addDoc(collection(db, 'servicios'), {
        ...servicio,
        uid,
        imagenURL,
        portafolio: portafolioUrls,
        categoria: categoriaSeleccionada.label,

        fechaCreacion: serverTimestamp(),
        fechaActualizacion: serverTimestamp(),
        paquetes: servicio.paquetes.map(p => ({
          ...p,
          precio: Number(p.precio),
        }))
      });

      setMensaje('Servicio creado exitosamente.');
      window.location.href = '/perfil/' + uid;

      setServicio({
        categoria: '',
        nombre: '',
        descripcion: '',
        imagenURL: '',
        bio: '',
        modalidad: '',
        instruccionesReserva: '',
        faq: [{ pregunta: '', respuesta: '' }],
        paquetes: [{ nombre: '', descripcion: '', precio: '' }],
        testimonios: [],
        ubicacion: null,

      });
      setFotoFile(null);
    } catch (error) {
      console.error('Error creando servicio:', error);
      setMensaje('Error al crear el servicio.');
    }
    navigate('/servicios')
    setGuardando(false);
  };

  const getIcon = (iconName) => {
    const IconComponent = FaIcons[iconName];
    if (!IconComponent) return <FaIcons.FaRegQuestionCircle />;
    return <IconComponent />;
  };
  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;
    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;
    // Retorna true o false seguro
    return prefersDark || isNight;
  });

  // Cargar el tema al inicio (localStorage, sistema u hora)
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      // Detecta modo oscuro sistema
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      // Detecta modo oscuro por hora (7pm - 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;

      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Función para cambiar el modo
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

  if (guardando === true) {
    return <LoadingScreen />
  }

  return (
    <>
      {step === 0 && (
        <div className="main_service_container">
          <h2>¿Qué tipo de servicio ofreces?</h2>
          <div className="categorias-lista">
            {categorias.map((cat) => (
              <div
                key={cat.id} // cuidado: es IdTipoEspacio, no espacio.id
                className={`categoria-item ${categoriaSeleccionada === (cat) ? 'seleccionada' : ''}`}
                onClick={() => handleCategoriaClick(cat)} // Actualiza el estado global
              >
                <span className="icon_categorias">{getIcon(cat.icon)}</span>
                <br />
                <span className="label">{cat.label}</span>
              </div>
            ))}
          </div>
          <button className="btn_siguiente_service" onClick={handleSiguiente}>Siguiente</button>
        </div>
      )
      }{step === 1 && (
        <div className="main_service_container">
          <div className="formulario_con_imagen">
            <div className="formulario_info">
              <h1 className="titulo_formulario">¡Crea tu servicio!</h1>
              <p className="frase_inspiradora">Conecta con quienes necesitan lo que tú sabes hacer.</p>

              <label htmlFor="nombre">Nombre del servicio</label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={servicio.nombre}
                onChange={handleChange}
                placeholder="Ej. Diseño Web Profesional"
                required
              />

              <label htmlFor="descripcion">Háblanos de lo que ofreces</label>
              <textarea
                id="descripcion"
                name="descripcion"
                value={servicio.descripcion}
                onChange={handleChange}
                placeholder="Describe tus servicios, beneficios o lo que te hace diferente."
                required
              />

             
            </div>

            <div className="formulario_imagen">
              <span className="imagen_categoria">{getIcon(categoriaSeleccionada.icon)}              <h1>{categoriaSeleccionada.label}</h1></span>

            </div>
          </div>
           <div className="botones_navegacion">
                <button className="btn_regresar_service" onClick={handleAnterior}>Regresar</button>
                <button className="btn_siguiente_service" onClick={handleSiguiente}>Siguiente</button>
              </div>
        </div>
      )}
      {
        step === 2 && (
          <div className="main_service_container">
            <h1 className="foto_titulo">¡Haz que tu servicio resalte!</h1>
            <p className="foto_subtitulo">
              Sube una imagen representativa que ayude a tus clientes a entender lo que ofreces de un vistazo.
              Puede ser una foto real, un logo o algo que inspire confianza.
            </p>            <input type="file" accept="image/*" onChange={handleFotoChange} />
            {fotoFile && (
              <img className='foto-servicio'
                src={URL.createObjectURL(fotoFile)}
                alt="Preview"
                style={{ width: 150, height: 150, objectFit: 'cover', marginTop: 10, borderRadius: 8 }}
              />
            )}
            <div className="botones_navegacion">
              <button className="btn_regresar_service" onClick={handleAnterior}>Regresar</button>
              <button className="btn_siguiente_service" onClick={handleSiguiente}>Siguiente</button>
            </div></div>
        )
      }
      {
        step === 3 && (
          <div className="main_service_container">
            <div className="modalidad_container">
              <h1 className="modalidad_label">¿Dónde ofreces tus servicios?</h1>
              <p className="modalidad_info">
                Selecciona si brindas tus servicios de forma presencial, virtual o ambas (híbrido).
              </p>

              <div className="modalidad_opciones">
                {['Presencial', 'Virtual', 'Híbrido'].map((tipo) => (
                  <button
                    key={tipo}
                    type="button"
                    className={`modalidad_btn ${servicio.modalidad === tipo ? 'seleccionada' : ''}`}
                    onClick={() => handleChange({ target: { name: 'modalidad', value: tipo } })}
                  >
                    {tipo}
                  </button>
                ))}
              </div>

              {/* Mostrar ubicación solo si la modalidad es Presencial o Híbrida */}
              {(servicio.modalidad === 'Presencial' || servicio.modalidad === 'Híbrido') && (
                <div className="ubicacion_container">
                  <label className="ubicacion_label">Ubicación del servicio</label>
                  <MapaSeleccion location={servicio.ubicacion} setLocation={setUbicacion} />
                </div>
              )}
            </div>
            <div className="botones_navegacion">
              <button className="btn_regresar_service" onClick={handleAnterior}>Regresar</button>
              <button className="btn_siguiente_service" onClick={handleSiguiente}>Siguiente</button>
            </div>
          </div>
        )
      }

      {
        step === 4 && (
          <div className="main_service_container">
            <h1 className="paquetes_titulo">¡Define tus ofertas irresistibles!</h1>
            <p className="paquetes_subtitulo">
              Crea paquetes con nombres atractivos, descripciones claras y precios justos. Cuanto más claro seas, más fácil será para tus clientes decidir.
            </p>

            <fieldset className="paquetes_fieldset">
              <legend className="paquetes_legend">Paquetes Disponibles</legend>

              {servicio.paquetes.map((pqt, i) => (
                <div key={i} className="paquete-item">
                  <input
                    className="input_nombre_paquete"
                    type="text"
                    placeholder="Nombre del paquete"
                    value={pqt.nombre}
                    onChange={e => handlePaqueteChange(i, 'nombre', e.target.value)}
                    required
                  />

                  <textarea
                    className="textarea_descripcion_paquete"
                    placeholder="Descripción del paquete"
                    value={pqt.descripcion}
                    onChange={e => handlePaqueteChange(i, 'descripcion', e.target.value)}
                    rows={3}
                    required
                  />

                  <input
                    className="input_precio_paquete"
                    type="number"
                    placeholder="Precio (USD)"
                    value={pqt.precio}
                    onChange={e => handlePaqueteChange(i, 'precio', e.target.value)}
                    min="1"
                    step="0.01"
                    required
                  />

                  {servicio.paquetes.length > 1 && (
                    <button className="btn_eliminar_paquete" type="button" onClick={() => eliminarPaquete(i)}>
                      Eliminar
                    </button>
                  )}
                </div>
              ))}

              {servicio.paquetes.length < 3 && (
                <button className="btn_agregar_paquete" type="button" onClick={agregarPaquete}>
                  + Agregar otro paquete
                </button>
              )}
            </fieldset>
            <div className="botones_navegacion">
              <button className="btn_regresar_service" onClick={handleAnterior}>Regresar</button>
              <button className="btn_siguiente_service" onClick={handleSiguiente}>Siguiente</button>
            </div>
          </div>

        )
      }
      {
        step === 5 && (
          <div className="main_service_container">
            <h2 className="portafolio_titulo">¡Impulsa la confianza con tu trabajo!</h2>
            <p className="portafolio_subtitulo">
              Sube imágenes o archivos PDF que representen tu experiencia. Un buen portafolio puede ser decisivo para que los clientes te elijan.
            </p>

            <label className="portafolio_label">Portafolio (PDFs o Imágenes)</label>
            <input
              className="input_portafolio"
              type="file"
              multiple
              accept="image/*,.pdf"
              onChange={(e) => {
                const nuevos = Array.from(e.target.files);
                setPortafolioFiles((prev) => {
                  const existentes = new Set(prev.map(f => f.name));
                  const filtrados = nuevos.filter(f => !existentes.has(f.name));
                  return [...prev, ...filtrados];
                });
              }}
            />

            <ul className="lista_portafolio">
              {portafolioFiles.map((file, index) => (
                <li key={index} className="item_portafolio">
                  {file.name}
                  <button
                    type="button"
                    className="btn_quitar_archivo"
                    onClick={() =>
                      setPortafolioFiles((prev) => prev.filter((_, i) => i !== index))
                    }
                  >
                    Quitar
                  </button>
                </li>
              ))}
            </ul>

            <div className="botones_navegacion">
              <button className="btn_regresar_service" onClick={handleAnterior}>Regresar</button>
              <button className="btn_siguiente_service" onClick={handleSiguiente}>Siguiente</button>
            </div>
          </div>

        )
      }
      {
        step === 6 && (
          <div className="main_service_container">
            <h2 className="instrucciones_titulo">¿Cómo pueden reservar tu servicio?</h2>
            <p className="instrucciones_subtitulo">
              Escribe las instrucciones detalladas que tus clientes deben seguir para reservar. Sé claro y específico.
            </p>

            <label className="instrucciones_label">Instrucciones para Reservar</label>
            <textarea
              name="instruccionesReserva"
              className="input_instrucciones"
              value={servicio.instruccionesReserva}
              onChange={handleChange}
              placeholder="Ejemplo: Contáctame por WhatsApp y elige un horario disponible..."
              rows={5}
            />

            <fieldset className="faq_fieldset">
              <legend>Preguntas Frecuentes (FAQ)</legend>
              {servicio.faq.map((item, i) => (
                <div key={i} className="faq-item">
                  <input
                    className="faq-input"
                    type="text"
                    placeholder="Pregunta"
                    value={item.pregunta}
                    onChange={e => handleFaqChange(i, 'pregunta', e.target.value)}
                  />
                  <input
                    className="faq-input"
                    type="text"
                    placeholder="Respuesta"
                    value={item.respuesta}
                    onChange={e => handleFaqChange(i, 'respuesta', e.target.value)}
                  />
                  {servicio.faq.length > 1 && (
                    <button
                      type="button"
                      className="btn_eliminar_faq"
                      onClick={() => eliminarFaq(i)}
                    >
                      Eliminar
                    </button>
                  )}
                </div>
              ))}

              {servicio.faq.length < 5 && (
                <button type="button" className="btn_agregar_faq" onClick={agregarFaq}>
                  Agregar Pregunta
                </button>
              )}
            </fieldset>

            <div className="botones_navegacion">
              <button className="btn_regresar_service" onClick={handleAnterior}>Regresar</button>
              <button className="btn_siguiente_service" onClick={handleSiguiente}>Siguiente</button>
            </div>
          </div>

        )
      }
      {step === 7 && (
        <div className="main_service_container preview_container">
          <h1 className="preview_titulo">Previsualización del Servicio</h1>

          <div className="preview_section">
            <h2>{servicio.nombre}</h2>
            <p><strong>Categoría:</strong> {categoriaSeleccionada.label}</p>
            <p><strong>Descripción:</strong> {servicio.descripcion}</p>
            <p><strong>Modalidad:</strong> {servicio.modalidad}</p>

            {(servicio.modalidad === 'Presencial' || servicio.modalidad === 'Híbrido') && (
              <p><strong>Ubicación:</strong> {servicio.ubicacion?.direccion || 'No especificada'}</p>
            )}

            {fotoFile && (
              <img
                src={URL.createObjectURL(fotoFile)}
                alt="Imagen del servicio"
                className="preview_foto"
              />
            )}

            <h3>Paquetes</h3>
            <ul>
              {servicio.paquetes.map((p, i) => (
                <li key={i}>
                  <strong>{p.nombre}</strong>: {p.descripcion} - ${p.precio}
                </li>
              ))}
            </ul>

            <h3>Instrucciones para Reservar</h3>
            <p>{servicio.instruccionesReserva}</p>

            <h3>Preguntas Frecuentes</h3>
            <ul>
              {servicio.faq.map((item, i) => (
                <li key={i}>
                  <strong>{item.pregunta}</strong>: {item.respuesta}
                </li>
              ))}
            </ul>

            {portafolioFiles.length > 0 && (
              <>
                <h3>Portafolio</h3>
                <ul>
                  {portafolioFiles.map((file, i) => (
                    <li key={i}>{file.name}</li>
                  ))}
                </ul>
              </>
            )}
          </div>

          <div className="botones_navegacion">
            <button className="btn_regresar_service" onClick={handleAnterior}>Editar</button>
            <button onClick={handleSubmit} disabled={guardando} className="btn_guardar_service">
              {guardando ? 'Guardando...' : 'Publicar Servicio'}
            </button>
          </div>

          {mensaje && <p className="mensaje">{mensaje}</p>}
        </div>
      )}

    </>
  );
};

export default CrearServicio;
